<template>
  <div v-if="userData?.isSuperAdmin" class="mt-2 flex overflow-hidden flex-grow bg-trader-gray ">
    <div class="overflow-hidden flex flex-col  flex-grow mr-2">

      <!-- Hauptbereich -->
      <div class="flex-grow overflow-hidden px-10 h-full flex flex-col text-center justify-center p-4 bg-white">
        <div class=" rounded   ">

          <!-- Titel -->
          <div class="flex-shrink-0 flex items-center justify-between w-full h-10 mb-6 rounded">
            <div class="w-full  p-3 rounded">
              <span class="text-xl font-semibold">Tabellen-Struktur: {{ tableName }}</span>
            </div>
          </div>


          <!-- Spalten Info Box -->
          <div class="flex p-2 justify-between rounded mb-6 bg-trader-dark-gray">
            <div class="flex text-sm gap-4  items-center">
              <span><strong>Tabelle:</strong> {{ tableName }}</span>
              <span><strong>Einträge:</strong> {{ formateToTotalCount(tableData?.totalCount || 0) }}</span>
              <span><strong>Spalten:</strong> {{ tableData?.columns?.length || 0 }}</span>
              <span><strong>Aktuelle Zeilen:</strong> {{ tableData?.rows?.length || 0 }}</span>
            </div>
            <div class="flex text-sm gap-4">
              <button @click="showFilterRow = !showFilterRow"
                      :class="['px-2 py-1 rounded min-w-[70px]',showFilterRow ? 'bg-blue-600 text-white' : 'bg-white '  ]">
                <i class="fas fa-filter mr-2"></i> Filter
              </button>

              <button
                  @click="clearFilters"
                  class="px-2 py-1 bg-white  rounded text-sm"
              >
                Filter löschen
              </button>
              <button
                  @click="saveChanges"
                  class="px-2 py-1 bg-white  rounded text-sm"
              >
               Änderungen speichern
              </button>
            </div>
          </div>
        </div>
        <!-- Tabelle mit Daten -->
        <div v-if="!loading" class=" overflow-auto  flex-grow ">
          <table class="w-full text-left">
            <thead class="bg-trader-dark-gray sticky top-0">
            <tr class="border-b-2 dark:border-trader-gray">
              <th class="p-2">#</th>
              <th v-for="column in tableData.columns" :key="column" class="p-2 ">
                {{ column }}
              </th>
              <th class="w-full"></th>
            </tr>

            <!-- Filter Row -->
            <tr v-if="showFilterRow" class="bg-trader-light-gray">
              <th class="p-2 border-r border-trader-gray"><i class="fa-solid fa-magnifying-glass"></i></th>
              <th v-for="column in tableData.columns" :key="`filter-${column}`" class="p-2 border-r border-trader-gray">
                <div class="flex gap-1">
                  <select
                      v-model="filters[column].operator"
                      class="text-xs border rounded px-1 py-1 w-12"
                      @change="checkBeforeLoadData(column)"
                  >
                    <option value="=">=</option>
                    <option value="!=">!=</option>
                    <option value=">">></option>
                    <option value="<"><</option>
                    <option value=">=">≥</option>
                    <option value="<=">≤</option>
                    <option value="contains">enthält</option>
                    <option value="not_contains">enthält nicht</option>
                  </select>

                  <input

                      v-model="filters[column].value"

                      type="text"
                      placeholder="..."
                      class="text-xs border rounded px-2 py-1 flex-grow max-w-[80px] min-[80px]"
                      @keyup.enter="loadData"
                  >
                </div>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in tableData.rows" :key="index" class="border-b-2 dark:border-trader-gray">
              <td class="p-2 border-r border-trader-gray">{{ index + 1 }}</td>
              <td v-for="(cellValue, cellIndex) in row" :key="cellIndex" class="p-2 border-r border-trader-gray">
                <span class="">
                  <input @change="onFilterChange(row, $event, cellIndex)"
                         :disabled="cellIndex === 0"
                         class="px-1" :value="cellValue">
                </span>
              </td>
              <td class="w-full"></td>
            </tr>

            </tbody>
          </table>
        </div>
        <!-- Loading -->
        <div v-else-if="loading" class="text-center py-10 h-full">
          <p class="text-xl mb-2">Laden...</p>
        </div>
        <!-- Keine Daten gefunden -->
        <div v-else class="text-center py-10 ">
          <p class="text-xl mb-2">Keine Daten gefunden</p>
          <p v-if="tableData?.totalCount === 0">Die Tabelle ist leer.</p>
        </div>

        <div class="bg-trader-gray min-h-[50px] mt-4 flex items-center justify-center gap-2 px-4">
          <!-- Ganz zum Anfang -->
          <button
              class="flex items-center justify-center w-10 h-10 rounded-lg bg-white shadow-sm hover:bg-gray-50 hover:shadow-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              @click="goToFirstPage" :disabled="offset === 0">
            <i class="fas fa-angle-double-left text-trader-text"></i>
          </button>

          <!-- Ein Schritt zurück -->
          <button
              class="flex items-center justify-center w-10 h-10 rounded-lg bg-white shadow-sm hover:bg-gray-50 hover:shadow-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              @click="goToPreviousPage" :disabled="offset === 0">
            <i class="fas fa-angle-left text-trader-text"></i>
          </button>

          <!-- Seiten-Info -->
          <div class="flex items-center gap-2 mx-4 text-sm text-trader-text">
            <span class="font-medium text-trader-text">{{ getCurrentPageFromOffset(offset) }}</span>
            <span>von</span>
            <span class="font-medium text-trader-text">{{ getLastPageFromTotalCount(tableData?.totalCount) }}</span>
          </div>

          <!-- Ein Schritt vor -->
          <button
              class="flex items-center justify-center w-10 h-10 rounded-lg bg-white shadow-sm hover:bg-gray-50 hover:shadow-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              @click="goToNextPage" :disabled="offset + limit >= tableData?.totalCount">
            <i class="fas fa-angle-right text-trader-text"></i>
          </button>

          <!-- Ganz zum Ende -->
          <button
              class="flex items-center justify-center w-10 h-10 rounded-lg bg-white shadow-sm hover:bg-gray-50 hover:shadow-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              @click="goToLastPage" :disabled="offset + limit >= tableData?.totalCount">
            <i class="fas fa-angle-double-right text-trader-text"></i>
          </button>
        </div>

      </div>
    </div>

    <!-- Sidebar -->
    <Sidebar/>
  </div>
</template>

<script setup >
import {computed, onMounted, ref, watch} from 'vue';
import {useRoute} from 'vue-router';
import Sidebar from "@/components/Administration/Sidebar.vue";
import {mutation, query} from "@/graphql";
import {useStore} from "vuex";

const route = useRoute();
const tableName = ref('_user');
const loading = ref(false);
const limit = ref(1000);
const offset = ref(0);
const showFilterRow = ref(false);
const filters = ref({});
const tableData = ref(null);
const store = useStore();
const userData = computed(() => store.state.user.userData);

watch(() => tableData.value?.columns, (columns) => {
  if (columns) {
    columns.forEach(column => {
      if (!filters.value[column]) {
        filters.value[column] = {operator: '=', value: ''};
      }
    });
  }
});

// Reaktiver State für geänderte Felder
// Reaktiver State für geänderte Felder
const fieldChanges = ref({});
const changesArray = ref([]);

const onFilterChange = (row, event, cellIndex, rowIndex) => {
  changesArray.value.push({
    id: row[0],
    idName: tableData.value.columns[0],
    value: event.target.value,
    columnName: tableData.value?.columns[cellIndex],
  })
}



async function loadData() {
  loading.value = true;

  // Filter in das richtige Format für GraphQL konvertieren
  const activeFilters = [];
  Object.keys(filters.value).forEach(column => {
    if (filters.value[column].value) {
      activeFilters.push({
        column: column,
        operator: filters.value[column].operator,
        value: filters.value[column].value
      });
    }
  });

  console.log("Active Filters:", activeFilters);

  // Filter als 4. Parameter an GraphQL übergeben
  const [data, error] = await query.getDataFromTable(
      tableName.value,
      limit.value,
      offset.value,
      activeFilters  // Hier die Filter übergeben
  );

  if (error) {
    console.error("Error fetching table data:", error);
    loading.value = false;
    return;
  }

  tableData.value = data;
  loading.value = false;
}

function checkBeforeLoadData(column) {

  if (filters.value[column].value !== "") {
    loadData();
    return;
  }
}

function clearFilters() {
  Object.keys(filters.value).forEach(column => {
    filters.value[column] = {operator: '=', value: ''};
  });
  offset.value = 0;
  loadData();
}

async function saveChanges(){
  // Hier können Sie die Logik zum Speichern der Änderungen implementieren
  console.log("Changes saved (not implemented)", changesArray.value);
  const [_, error] = await mutation.saveTableData(tableName.value,changesArray.value);
  if (error) {
    console.error("Error saving table data:", error);
    return;
  }
  await loadData();

}

function goToFirstPage() {
  offset.value = 0;
  loadData();
}

function goToPreviousPage() {
  offset.value -= limit.value;
  loadData();
}

function goToNextPage() {
  offset.value += limit.value;
  loadData();
}

function goToLastPage() {
  offset.value = (Math.ceil(tableData.value.totalCount / limit.value) - 1) * limit.value;
  loadData();
}

function getCurrentPageFromOffset(offsetValue) {
  return Math.floor(offsetValue / limit.value) + 1;
}

function getLastPageFromTotalCount(totalCount) {
  return Math.ceil(totalCount / limit.value);
}

function formateToTotalCount(totalCount) {
  return totalCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}


watch(() => route.params.tableName, async (newTableName) => {
  if (newTableName && typeof newTableName === 'string') {
    tableName.value = newTableName;
    offset.value = 0;
    await loadData();
  }
}, {immediate: true});

onMounted(async () => {
  tableName.value = route.params.tableName;
  await loadData();
});
</script>